// @ts-ignore
import * as keyboardKey from 'keyboard-key';

var isKeyModifiersMatch = function isKeyModifiersMatch(modifierValue, combinationValue) {
  if (combinationValue === undefined) {
    return true;
  }

  return modifierValue === combinationValue;
};

var shouldHandleOnKeys = function shouldHandleOnKeys(event, keysCombinations) {
  return keysCombinations.some(function (keysCombination) {
    return keysCombination.keyCode === keyboardKey.getCode(event) && isKeyModifiersMatch(event.altKey, keysCombination.altKey) && isKeyModifiersMatch(event.shiftKey, keysCombination.shiftKey) && isKeyModifiersMatch(event.metaKey, keysCombination.metaKey) && isKeyModifiersMatch(event.ctrlKey, keysCombination.ctrlKey);
  });
};

export default shouldHandleOnKeys;